export type OrderbookStreamStatus = 'idle' | 'connecting' | 'ready' | 'error';

export function shouldResyncOnDocumentVisibleChange(
  previousIsVisible: boolean,
  nextIsVisible: boolean
) {
  return !previousIsVisible && nextIsVisible;
}

export function shouldResyncOnStreamReady({
  previousStatus,
  nextStatus,
  hasSeenReady,
}: {
  previousStatus: OrderbookStreamStatus;
  nextStatus: OrderbookStreamStatus;
  hasSeenReady: boolean;
}) {
  return hasSeenReady && previousStatus !== 'ready' && nextStatus === 'ready';
}
